<template>
  <ion-card ref="card" class="ion-margin" v-if="value.length">
    <ion-card-header>
      <ion-card-subtitle>
        {{ subTitle }}
      </ion-card-subtitle>
      <ion-card-title>
        {{ title }}
      </ion-card-title>
    </ion-card-header>
    <ion-card-content>
      <ion-list>
        <ion-item
          lines="none"
          v-for="repo in value"
          v-motion
          :initial="{
            opacity: 0,
            x: 100
          }"
          :visible="{
            opacity: 1,
            x: 0,
            transition: {
              duration: 300,
              type: 'keyframes',
              ease: 'easeIn',
            }
          }"
          :key="repo.TableItemSeqId"
        >
          {{ repo.TableItemSeqId }}. {{ repo.TableItemLabel }}
          <ion-label slot="end" v-if="repo.TableItemMeta">{{ repo.TableItemMeta }} {{ suffix ? repo.TableItemMeta == 1 ? suffix : suffix + "s" : "" }}</ion-label>
        </ion-item>
      </ion-list>
    </ion-card-content>
  </ion-card>
</template>

<script setup lang="ts">
import { IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonLabel, IonList, IonItem } from "@ionic/vue";
import { defineProps, onMounted, ref } from "vue";
import { useMotion } from "@vueuse/motion";

defineProps({
  subTitle: {
    type: String,
    required: true
  },
  title: {
    type: String,
    required: false
  },
  value: {
    type: Object,
    required: true
  },
  suffix: {
    type: String,
    required: false
  }
})

const card = ref()

const { variant } = useMotion(card, {
  initial: {
    opacity: 0,
    y: 100
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 300,
      type: 'keyframes',
      ease: 'easeIn',
    },
  }
})

</script>

<style scoped>
ion-list {
  background: transparent !important;
}
</style>